import { Component, inject, OnInit } from '@angular/core';
import { PreferencesService } from '../../services/preferences/preferences.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [],
  templateUrl: './root.component.html',
  styleUrl: './root.component.css'
})
export class RootComponent implements OnInit {
  
  private readonly $preferences = inject(PreferencesService) ;
  private readonly $router = inject(Router) ;

  ngOnInit(): void {

    if (this.$preferences.userType() == 'teacher') {
      this.$router.navigate(['/admin'], { skipLocationChange: true }) ;
    } else {
      this.$router.navigate(['/student'], { skipLocationChange: true }) ;
    }
    
  }


}
